import PanelData from '@/view/women-world-cup-personal-summary/PanelData.vue'
import TeamPage from '@/view/women-world-cup-personal-summary/TeamPage.vue'
import PlayerSummary from '@/view/women-world-cup-personal-summary/PlayerSummary.vue'
import PlayerPersonal from '@/view/women-world-cup-personal-summary/PlayerPersonal.vue'
import Content from '@/view/women-world-cup-personal-summary/Content.vue'
import TeamAnalysis from '@/view/women-world-cup-personal-summary/TeamAnalysis.vue'

import { RouteRecordRaw, RouterView } from 'vue-router'

export default {
    name: '',
    path: '/',
    redirect: '/home',
    meta: {
        title: '中国女篮世预选赛总结',
    },
    component: RouterView,
    children: [
        {
            name: 'worldCupQualifier',
            path: 'home',
            component: () => import('@/view/women-world-cup-personal-summary/index.vue'),
        },
        {
            name: 'worldCupPanelData',
            path: 'world-cup-panel-data',
            component: PanelData,
        },
        {
            name: 'TeamPage',
            path: 'world-cup-TeamPage',
            component: TeamPage,
        },
        {
            name: 'TeamAnalysis',
            path: 'world-cup-TeamAnalysis',
            component: TeamAnalysis,
        },

        {
            name: 'PlayerSummary',
            path: 'world-cup-play-PlayerSummary',
            component: PlayerSummary,
        },
        {
            name: 'PlayerPersonal',
            path: 'world-cup-play-PlayerPersonal',
            component: PlayerPersonal,
        },
        {
            name: 'Content',
            path: 'world-cup-Content',
            component: Content,
        },
    ],
} as RouteRecordRaw
